var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Folder Open",
    id: "Folder_Open"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.24,15.45A2.41,2.41,0,0,0,28,14.63V13.5a3,3,0,0,0-3-3H17.62L16.45,8.16A3,3,0,0,0,13.76,6.5H8a3,3,0,0,0-3,3v1.78A3,3,0,0,0,4,13.5v9a3,3,0,0,0,.45,1.58l.13.15a2.34,2.34,0,0,0,.19.33,2.52,2.52,0,0,0,2,1h18a3.8,3.8,0,0,0,3.5-2.74l1.34-5A2.63,2.63,0,0,0,29.24,15.45ZM25,12.5a1,1,0,0,1,1,1v1H9.21a3.79,3.79,0,0,0-3.21,2v-3a1,1,0,0,1,1-1H25ZM7,9.5a1,1,0,0,1,1-1h5.76a1,1,0,0,1,.89.55l.72,1.45H7Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.8e4599eb0689e5ba123abbe2c5c64fa8.svg";
export { ForwardRef as ReactComponent };